import type { Subscription } from '@/common/utils';

export class Subscriptions {
  private subscriptions: Subscription[] = [];

  add(subscription: Subscription): this {
    this.subscriptions.push(subscription);
    return this;
  }

  unsubscribe(): void {
    this.subscriptions.forEach((subscription: Subscription) => {
      if (typeof subscription.unsubscribe === 'function') {
        subscription.unsubscribe();
      }
    });
  }
}
